export const projectLabelConstant = {
  "170": {
    department: "Sponsoring Department",
    name: "Project / Scheme Name",
    description: "Brief Project Description / Development Objectives"
  },
  "150": {
    department: "Sponsoring Department"
  }
};
